import { FORMS, MODULES } from "../const";

export const routePermissions = [
  {
    linkName: "/master/gs-division",
    form: FORMS.GS_DIVISION.GS.form,
    module: MODULES.Master,
    label: "Grama Niladhari Division",
  },
  {
    linkName: "/master/employee",
    form: FORMS.EMPLOYEE.EMP.form,
    module: MODULES.Master,
    label: "Employee",
  },
  {
    linkName: "/master/vehicle",
    form: FORMS.VEHICLE.VEH.form,
    module: MODULES.Master,
    label: "Vehicle",
  },
  {
    linkName: "/master/police-division",
    form: FORMS.POLICE_DIVISION.POL.form,
    module: MODULES.Master,
    label: "Police Division",
  },
  {
    linkName: "/master/bank-branch",
    form: FORMS.BANK_BRANCH.BNK_BRN.form,
    module: MODULES.Master,
    label: "Bank Branch",
  },
  {
    linkName: "/master/vehicle-type",
    form: FORMS.VEHICLE.TYPE.form,
    module: MODULES.Master,
    label: "Vehicle Type",
  },
  {
    linkName: "/master/trailers",
    form: FORMS.TRAILERS.TRL.form,
    module: MODULES.Master,
    label: "Trailers",
  },
  {
    linkName: "/master/agreements",
    form: FORMS.AGREEMENT.AGR.form,
    module: MODULES.Master,
    label: "Agreement",
  },
  {
    linkName: "/master/location-creation",
    form: FORMS.LOCATION.LOC.form,
    module: MODULES.Master,
    label: "Location Creation",
  },
  {
    linkName: "/master/stakeholder",
    form: FORMS.STAKEHOLDER.STK.form,
    module: MODULES.Master,
    label: "Stakeholder",
  },
  {
    linkName: "/master/cluster-creation",
    form: FORMS.CLUSTER.CLU.form,
    module: MODULES.Master,
    label: "Cluster Master",
  },
  {
    linkName: "/master/stakeholder-group-creation",
    form: FORMS.STAKEHOLDER_GROUP.GRP.form,
    module: MODULES.Master,
    label: "Stakeholder Group",
  },
  {
    linkName: "/master/blacklist",
    form: FORMS.BLACKLIST.BLK.form,
    module: MODULES.Master,
    label: "Black List",
  },
  {
    linkName: "/master/item-creation",
    form: FORMS.ITEM.TEM.form,
    module: MODULES.Master,
    label: "Item",
  },
  {
    module: MODULES.Master,
    form: FORMS.GEO_MANAGER.GEO.form,
    label: "Geo Manager",
    linkName: "/master/geographical-management",
  },
  {
    label: "Dynamic Template",
    module: MODULES.Fleet,
    form: FORMS.TEMPLATE.DYNAMIC_TEM.form,
    linkName: "/fleet/template-create",
  },
  {
    label: "Document Management",
    module: MODULES.Fleet,
    form: FORMS.FLEET.DOCUMENT_MANAGEMENT.form,
    linkName: "/fleet/document-management",
  },
  {
    label: "Inspection Process",
    module: MODULES.Fleet,
    form: FORMS.FLEET_INSPECTION.INSPECTION_PROCESS.form,
    linkName: "/fleet/inspection-process",
  },
  {
    label: "MIS Report",
    module: MODULES.MIS,
    form: FORMS.MIS.REPORT.form,
    linkName: "/mis/mis-report",
  },
  {
    label: "Dashboard",
    module: MODULES.Fleet,
    form: FORMS.FLEET_DASHBORARD.DASHBORARD.form,
    linkName: "/fleet/fleet-dashboard",
  },
  {
    linkName: "/master/deduction-approval",
    form: FORMS.ITEM.APPROVAL.form,
    module: MODULES.Master,
    label: "Approval",
  },
  {
    linkName: "/transaction/request-creation",
    form: FORMS.REQUEST.CREATION.form,
    module: MODULES.Transaction,
    label: "Request Creation",
  },
  {
    linkName: "/transaction/request-approval",
    form: FORMS.REQUEST_APPROVAL.APPROVAL.form,
    module: MODULES.Transaction,
    label: "Request Approval",
  },
  {
    linkName: "/transaction/job-monitoring",
    form: FORMS.JOB.MONITOR.form,
    module: MODULES.Transaction,
    label: "Job Monitoring",
  },
  {
    linkName: "/transaction/fuel-request-panel",
    form: FORMS.FUEL_REQUEST.HEADER.form,
    module: MODULES.Transaction,
    label: "Fuel Request",
  },
  {
    linkName: "/transaction/job-monitoring/:id/:popup",
    form: FORMS.JOB.MONITOR.form,
    module: MODULES.Transaction,
    label: "Job Monitoring",
  },
  {
    linkName: "/transaction/ncr-upload",
    form: FORMS.NCR.UPLOAD,
    module: MODULES.Transaction,
    label: "NCR Upload",
  },
  {
    linkName: "/finance/exchangeRate",
    form: FORMS.EXCHANGE_RATE.EXC.form,
    module: MODULES.Finance,
    label: "Exchange Rate",
  },
  {
    linkName: "/finance/rate-manager",
    form: FORMS.RATE_MANAGER.HEADER.form,
    module: MODULES.Finance,
    label: "Rate Manager",
  },
  {
    linkName: "/finance/charge",
    form: FORMS.CHARGE_CREATION.HEADER.form,
    module: MODULES.Finance,
    label: "Charge Creation",
  },
  {
    linkName: "/finance/transporter-invoice",
    form: FORMS.TRANSPORTER_INVOICE.INVOICE.form,
    module: MODULES.Finance,
    label: "Transporter Invoice",
  },
  {
    linkName: "/finance/charge-confirmation",
    form: FORMS.CHARGE_APPROVAL.HEADER.form,
    module: MODULES.Finance,
    label: "Charge Approval",
  },
  {
    linkName: "/finance/ev-inv-generator",
    form: FORMS.EV_INV_MANAGER.HEADER.form,
    module: MODULES.Finance,
    label: "EV/INV Manager",
  },
  {
    linkName: "/finance/supplier-payment-hold",
    form: FORMS.SUPPLIER_PAYMENT_HOLD.HEADER.form,
    module: MODULES.Finance,
    label: "Payment Hold",
  },
  {
    linkName: "/finance/ev-inv-approve",
    form: FORMS.EV_INV_APPROVAL.HEADER.form,
    module: MODULES.Finance,
    label: "EV/INV Approval",
  },
  {
    linkName: "/finance/tax-management",
    form: FORMS.TAX_MANAGER.HEADER.form,
    module: MODULES.Finance,
    label: "Tax Manager",
  },
  {
    linkName: "/finance/charge-type",
    form: FORMS.TAX_MANAGER.HEADER.form,
    module: MODULES.Finance,
    label: "Charge Type",
  },
  {
    linkName: "/finance/deduction-master",
    form: FORMS.APPROVAL_MANAGER.APPROVAL_MANAGER,
    module: MODULES.Finance,
    label: "Deduction",
  },
  {
    linkName: "/finance/approvalProcess",
    form: FORMS.APPROVAL_MANAGER.APPROVAL_MANAGER,
    module: MODULES.Finance,
    label: "Approval Process",
  },
  {
    label: "Audit Report",
    module: MODULES.MIS,
    form: FORMS.MIS.REPORT.form,
    linkName: "/audit/audit-report",
  },
  {
    label: "Supplier Negotiation Approval",
    module: MODULES.Transaction,
    form: FORMS.APPROVAL.SUPPLIER_NEGOTIATION.form,
    linkName: "/transaction/approval/supplier-negotiation",
  },
  {
    label: "Financial Analytics",
    module: MODULES.MIS,
    form: FORMS.MIS.METABASE_FINANCE_ANALYTICS.form,
    linkName: "/mis/finance-analytics",
  },
  {
    label: "Live Analytics",
    module: MODULES.MIS,
    form: FORMS.MIS.METABASE_LIVE_ANALYTICS.form,
    linkName: "/mis/live-analytics",
  },
  {
    label: "Default Notification Alerts",
    module: MODULES.Admin,
    form: FORMS.ALERTS.ALR.form,
    linkName: "/admin/default-alert",
  },
  {
    label: "Revenue Distribution Report",
    module: MODULES.MIS,
    form: FORMS.MIS.REPORT.form,
    linkName: "/revenue/revenue-report",
  },
  {
    label: "Option Config",
    module: MODULES.Admin,
    form: FORMS.ALERTS.ALR.form,
    linkName: "/admin/option-config",
  },
];
